module.exports = __webpack_public_path__ + "img/icon01.73fbb928.png";